'use strict';

const ritualsStyles = require('./rituals-styles'),
    giftwrapping = require('./giftwrapping'),
    greetingcard = require('./greetingcard'),
    damHelper = require('./dam/dam-helper'),
    taxFreeThresholdPassedWarning = require('./pages/checkout/taxFreeThresholdPassedWarning');

const GiftWrap = function () {
    function init() {
        giftwrapping.init(updateGiftWrapAndGreetingCardBlockAndPrice);
        greetingcard.init(updateGiftWrapAndGreetingCardBlockAndPrice);
    }

    function updateGiftWrapAndGreetingCardBlockAndPrice(updatedHtml) {
        if (!updatedHtml) {
            return;
        }

        const $info = $(updatedHtml).filter('.js-giftwrap-updated-info');

        updateOrderTotals($info);

        updateGiftWrappingAndGreetingCardBlocks($info, '.js-giftwrapping-info', '.js-giftwrap');
        updateGiftWrappingAndGreetingCardBlocks($info, '.js-greetingcard-info', '.js-greetingcard');

        updateGiftWrappingAndGreetingCardLineItems($info, '.js-gift-wrapping-line-item', '.js-cart-giftwrapping-row');
        updateGiftWrappingAndGreetingCardLineItems($info, '.js-greetingcard-line-item', '.js-cart-greetingcard-row');
    }

    function updateGiftWrappingAndGreetingCardLineItems(info, cartItemClass, lineItemClass) {
        const $lineItem = $(cartItemClass, info);
        if ($lineItem.length) {
            const $cartItems = $('.js-cart-items');
            const $cartItem = $(lineItemClass, $cartItems);
            if ($cartItem.length) {
                $cartItem.replaceWith($lineItem.html());
                damHelper.updateImages($(lineItemClass, $cartItems));
                return;
            }

            $cartItems.append($lineItem.html());
            damHelper.updateImages($cartItems);
            return;
        }
    }

    function updateGiftWrappingAndGreetingCardBlocks(info, blockHolderClass, blockClass) {
        const $blockInfo = $(blockHolderClass, info);
        if ($blockInfo.length) {
            $(blockClass).replaceWith($blockInfo.html());
            damHelper.updateImages($(blockClass));
        }
    }

    function updateOrderTotals(info) {
        const $orderTotalsInfo = $('.js-order-totals-info', info);
        if (!$orderTotalsInfo.length) {
            return;
        }

        const orderSubtotalValue = $orderTotalsInfo.find('.js-order-subtotal-value');
        if (orderSubtotalValue.length) {
            $('.js-order-subtotal-value').html(orderSubtotalValue.html());
        }

        const totalPrice = $orderTotalsInfo.find('.js-order-value');
        if (totalPrice.length) {
            $('.js-order-value').html(totalPrice.html());
        }

        const taxFreeThresholdBlock = $orderTotalsInfo.find('.js-tax-warning-block');
        if (!taxFreeThresholdBlock.length) {
            return;
        }

        $('.js-tax-warning-block').html(taxFreeThresholdBlock.html());
        taxFreeThresholdPassedWarning.createDialog();
    }

    function showGiftWrapMessage(page, updateFunction, previousRadioButton, explanationText) {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.GIFTWRAP,
            },
            paragraphs: [
                {
                    text: explanationText
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.CONTINUE,
                    eventName: 'onGiftWrapModalPrimaryButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                eventName: 'onGiftWrapModalCloseElementClick',
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });

        window.eventBus.$off('onGiftWrapModalPrimaryButtonClick');
        window.eventBus.$off('onGiftWrapModalCloseElementClick');

        window.eventBus.$once('onGiftWrapModalPrimaryButtonClick', function() {
            if (updateFunction) {
                updateFunction();
            }
        });

        window.eventBus.$once('onGiftWrapModalCloseElementClick', function() {
            if (updateFunction && page !== 'checkout_page') {
                updateFunction();
            } else {
                if (previousRadioButton) {
                    previousRadioButton.prop('checked', true);
                }
            }
        });
    }

    function enableOrDisableGiftWrap(enable, rewrap, callback) {
        $.ajax({
            type: 'POST',
            url: Urls.enableOrDisableGiftWrap,
            data: 'enable=' + enable + '&rewrap=' + rewrap,
            success: function(data) {
                updateGiftWrapAndGreetingCardBlockAndPrice(data);

                greetingcard.onloadSetSelectedCard();
                initLazyLoad();

                if (callback && $.isFunction(callback)) {
                    callback();
                }
            }
        });
    }

    function getGiftwrapDataForSelectedShippingOption(shippingOption, page, previousRadioButton, callback) {
        $.ajax({
            type: 'POST',
            url: Urls.getGiftwrapDataForSelectedShippingOption,
            contentType: 'application/json',
            data: JSON.stringify({
                shippingOption: shippingOption,
                page: page
            })
        }).done(function(response) {
            if (!response || !response.giftWrapData) {
                if (callback && $.isFunction(callback)) {
                    callback();
                }
                return;
            }
            console.log(response.giftWrapData);

            if (!response.giftWrapData.showGiftWrapMessage) {
                enableOrDisableGiftWrap(response.giftWrapData.enable, response.giftWrapData.rewrap, callback);

                return;
            }

            showGiftWrapMessage(
                page,
                function () {
                    enableOrDisableGiftWrap(response.giftWrapData.enable, response.giftWrapData.rewrap, callback);
                },
                previousRadioButton,
                response.giftWrapData.giftWrapModalText
            );
        });
    }

    function initLazyLoad() {
        if ($('.js-lazy-load').length) {
            ritualsStyles.initLazyLoad();
        }
    }

    return {
        init: init,
        getGiftwrapDataForSelectedShippingOption: getGiftwrapDataForSelectedShippingOption
    };
};

module.exports = new GiftWrap();
